export default "__VITE_ASSET__96bd112a__"